    <!-- read-more.component.html -->
    <!-- <div *ngIf="!isExpanded">
        {{ truncatedText }}
        <span *ngIf="showReadMore">...</span>
      </div>
      <div *ngIf="isExpanded">
        {{ text }}
      </div>
      <button *ngIf="showReadMore" (click)="toggleView()">
        {{ isExpanded ? 'View less' : 'View more' }}
      </button> -->

      <!-- Truncated Text with View More -->
<div *ngIf="!isExpanded">
  {{ truncatedText }}
  <span *ngIf="showReadMore">...</span>
</div>

<!-- View More / View Less Button -->
<button *ngIf="showReadMore" type="button" class="btn btn-link p-0" (click)="viewMoredata()">
  View more
</button>

<!-- Bootstrap Modal for Full Text -->

